import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent, ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'reports-dashboards-library-empty-state',
  templateUrl: './library-empty-state.component.html',
  styleUrls: ['./library-empty-state.component.less'],
  imports: [NgOptimizedImage, HeadingComponent, ButtonComponent, IconComponent, TranslatePipe],
})
export class LibraryEmptyStateComponent {}
